export const FORM_UPLOAD_ACCEPT =
  ".jpeg,.jpg,.png,.pdf,.mp4,image/jpeg,image/png,application/pdf,video/mp4"

export const FORM_UPLOAD_MAX_BYTES = 20 * 1024 * 1024

export const FORM_UPLOAD_DISCLAIMER =
  "Only jpeg, png, pdf and mp4 allowed with maximum 20mb size"

const ALLOWED_EXTENSIONS = ["jpeg", "jpg", "png", "pdf", "mp4"]
const ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "video/mp4",
]

export const validateFormUploadFiles = (files) => {
  for (const file of files) {
    if (file.size > FORM_UPLOAD_MAX_BYTES) {
      return FORM_UPLOAD_DISCLAIMER
    }

    const extension = file.name.split(".").pop()?.toLowerCase() || ""
    const hasValidExtension = ALLOWED_EXTENSIONS.includes(extension)
    const hasValidMime =
      !file.type || ALLOWED_MIME_TYPES.includes(file.type.toLowerCase())

    if (!hasValidExtension || !hasValidMime) {
      return FORM_UPLOAD_DISCLAIMER
    }
  }

  return null
}
